import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { theme } from 'shared/styles/theme';

import Button from 'shared/styles/common/Button';

export default function FloorButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('view', 'floor');
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: false,
    });
  };

  return (
    <CustomButton size="sm" theme="point3-blue" onClick={handleClick}>
      도면보기
    </CustomButton>
  );
}

const CustomButton = styled(Button)`
  width: 72px;

  background-color: ${theme.colors.point3};
  color: ${theme.colors.point};
`;
